
import ObjArrUtils from '@/utils/ObjArrUtils'
import { Base } from '@/store/base/module'

import dot from 'dot-object'
import i18n from '@/plugins/i18n'

const module = {
  state: {
    names_no_dropdown: [],
    selected_names_no_description: null,
    M20601_getBatchEdit_input: {},
    M20601_getBatchEdit_output: null
  },
  getters: {

  },
  mutations: {

  },
  actions: {
    async M20601_getDropdownData ({ commit }) {
      const res = await $this.$api.postData({
        data: {
          M0010Setting_getDropdownData: {
            api: 'M0010SettingService.C00101_getDropdownData',
            input: {}
          }
        }
      })
      commit('setState', {
        names_no_dropdown: res.M0010Setting_getDropdownData.output
      })
    },
    async M20601_getBatchEdit ({ commit, state }, payload) {
      const res = await $this.$api.postData({
        data: {
          M20601_getBatchEdit:{
            api: 'M0020NamesService.M20601_getBatchEdit',
            input: state.M20601_getBatchEdit_input
          }
        }
      })
      commit('setState', {
        M20601_getBatchEdit_output: res.M20601_getBatchEdit.output
      });
    },
    async M20601_doBatchEdit ({ commit, state }, payload) {
      const temp = JSON.parse(JSON.stringify(state.M20601_getBatchEdit_output));
      try{
        const res = await $this.$api.postData({
          data: {
            M20601_doBatchEdit:{
              api: 'M0020NamesService.M20601_doBatchEdit',
              input: state.M20601_getBatchEdit_output
            }
          },
          databaseDiff:{
            tables: [
              'm0020_names',
            ]
          }
        })
        commit('setState', {
          M20601_getBatchEdit_output: res.M20601_doBatchEdit.output
        });
        window.vue.$dialog.notify.success(window.vue.$i18n.t('M20601.M20601Store.qs8OfkwTYmDVJNR4_WrBz'));
      } catch (error) {
        const res = JSON.parse(error.message)
        if(res.status === 422 && res.responseJSON.errorCode === 'VALIDATION_ERROR') {
          const errors = res.responseJSON.actions.errors
          dot.object(errors)
          for (let index = 0; index < temp.length; index++) {
            temp[index]['_error-messages'] = {};
            const targetBackendError = errors[index];
            if (targetBackendError) {
              temp[index]['_error-messages']= targetBackendError
            }
          }
          commit('setState', {
            M20601_getBatchEdit_output: temp
          });
          window.vue.$dialog.notify.info(window.vue.$i18n.t('M20601.M20601Store.KuJgXZhDUA5wu07yRin5y'));
        }
      }
    }
  }
}

export default ObjArrUtils.merge(Base, module)
